var map = {
	"./1.svg": 31523,
	"./2.svg": 42128,
	"./3.svg": 33249,
	"./4.svg": 15870,
	"./5.svg": 35919,
	"./6.svg": 33596,
	"./7.svg": 62141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55801;